// @flow
import React from 'react';
import { GlobalEvent, GlobalState } from './GlobalContext';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';

import DocInfoFormContent from './DocInfoFormContent';

export default function DocInfoEditDialog(props) {
  const { sysID } = props;

  const docDetail = props.data;
  const docTypes = props.docTypes || [];
  const folders = props.folders || [];
  const open = props.open || false;
  const onClose = props.onClose;
  const afterDocDetailUpdate = props.afterDocDetailUpdate;

  const [gState] = React.useContext(GlobalState);
  const [, gEventDispatch] = React.useContext(GlobalEvent);

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });
  };

  const handleCloseClick = () => {
    onClose && onClose();
  };

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="xl"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Document Info
      </DialogTitle>

      <DialogContent>
        <DocInfoFormContent
          sysID={sysID}
          sessionID={gState.sessionID}
          docDetail={docDetail}
          docTypes={docTypes}
          folders={folders}
          onCatchPromiseError={onCatchPromiseError}
          afterDocDetailUpdate={afterDocDetailUpdate}
          onRequestClose={handleCloseClick}
          readonly={false}
        />
      </DialogContent>
    </Dialog>
  );
}

DocInfoEditDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  sysID: PropTypes.string,
  data: PropTypes.object,
  docTypes: PropTypes.array,
  folders: PropTypes.array,
  afterDocDetailUpdate: PropTypes.func,
};